import { render, staticRenderFns } from "./StudentGroupsWidget.vue?vue&type=template&id=036e1813&scoped=true"
import script from "./StudentGroupsWidget.vue?vue&type=script&lang=js"
export * from "./StudentGroupsWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentGroupsWidget.vue?vue&type=style&index=0&id=036e1813&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e1813",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036e1813')) {
      api.createRecord('036e1813', component.options)
    } else {
      api.reload('036e1813', component.options)
    }
    module.hot.accept("./StudentGroupsWidget.vue?vue&type=template&id=036e1813&scoped=true", function () {
      api.rerender('036e1813', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/StudentGroupsWidget.vue"
export default component.exports